import apiConfig from "src/utils/apiConfig";

export const FETCH_PREPAID_TRIP = "prepaid/fetchPrepaidTripRequest";

export const fetchPrepaidTrip = (
  fromdate: any,
  todate: any,
  filter?: any,
  limit?: number,
  skip?: number
) => {
  let endpoint = `${apiConfig.PREPAIDTRIP}/?fromdate=${fromdate}&todate=${todate}`;

  if (filter && filter.trim() !== "") {
    endpoint += `&filter=${encodeURIComponent(filter.trim())}`;
  }
  if (limit !== undefined) {
    endpoint += `&limit=${limit}`;
  }
  if (skip !== undefined) {
    endpoint += `&skip=${skip}`;
  }
  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: FETCH_PREPAID_TRIP,
    payload: apiobject,
  };
};